import { FC, PropsWithChildren } from "react";
import { Box, Typography } from "@mui/material";
import { makeSxStyles } from "ui";

interface FieldRowProps extends PropsWithChildren {
  label: string;
  required?: boolean;
  description?: string;
  align?: "flex-start" | "center";
}

// A label-left / input-right form row (per the Figma lead form layout).
const FieldRow: FC<FieldRowProps> = ({
  label,
  required,
  description,
  align = "flex-start",
  children,
}) => {
  const styles = useStyles();

  return (
    <Box sx={{ ...styles.row, alignItems: align }}>
      <Box sx={{ ...styles.labelCol, pt: align === "center" ? 0 : "10px" }}>
        <Typography sx={styles.label}>
          {label}
          {required ? " *" : ""}
        </Typography>
        {description && (
          <Typography sx={styles.description}>{description}</Typography>
        )}
      </Box>
      <Box sx={styles.inputCol}>{children}</Box>
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  row: {
    display: "flex",
    flexDirection: "row",
    gap: "24px",
    mb: "16px",
  },
  labelCol: {
    width: "260px",
    flexShrink: 0,
  },
  label: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#c5c6c9",
  },
  description: {
    fontSize: "12px",
    lineHeight: "16px",
    color: "#c1c7ce",
    mt: "4px",
  },
  inputCol: {
    width: "360px",
    maxWidth: "100%",
  },
}));

export default FieldRow;
